import { render, staticRenderFns } from "./ContentPageAdd.vue?vue&type=template&id=1b701555&scoped=true&"
import script from "./ContentPageAdd.vue?vue&type=script&lang=js&"
export * from "./ContentPageAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b701555",
  null
  
)

export default component.exports